'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$() {
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_defaultMake$lzy1 = null;
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_defaultMakebitmap$1 = false;
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_make$lzy1 = null;
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_makebitmap$1 = false;
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_given_Show_Type$lzy1 = null;
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_given_Show_Typebitmap$1 = false;
  this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_validate = null;
  $n_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__$init$__V(this);
}
export { $c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ as $c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ };
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.constructor = $c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$;
/** @constructor */
function $h_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$() {
}
export { $h_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ as $h_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ };
$h_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype = $c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype;
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_defaultMakebitmap$1)) {
    this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_defaultMakebitmap$1 = true;
  }
  return this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_defaultMake$lzy1;
});
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_makebitmap$1)) {
    this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_makebitmap$1 = true;
  }
  return this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_make$lzy1;
});
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_given_Show_Typebitmap$1)) {
    this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_given_Show_Type$lzy1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_given_Show_Typebitmap$1 = true;
  }
  return this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_given_Show_Type$lzy1;
});
$c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$__f_validate;
});
var $d_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$, "app.api.app_updates$package$InMaintenanceMessage$", ({
  Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$Of: 1,
  Lframework_utils_NewtypeString: 1,
  Lframework_utils_NewtypeNonEmptyString: 1
}));
export { $d_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ as $d_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ };
var $n_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$;
function $m_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$() {
  if ((!$n_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$)) {
    $n_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ = new $c_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$();
  }
  return $n_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$;
}
export { $m_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ as $m_Lapp_api_app\uff3fupdates$package$InMaintenanceMessage$ };
//# sourceMappingURL=app.api.app_updates$package$-In-Maintenance-Message$.js.map
